import { isDefined, isFunction, isObject } from "./type";

export const EMPTY = {};
export const omitField = (obj, field) => {
  const { [field]: _, ...without } = obj;

  return without;
};

export const deepExtend = (target, values) => {
  if (isObject(target) && isObject(values)) {
    return Object.keys(values).reduce((acc, key) => {
      acc[key] = deepExtend(target[key], values[key]);

      return acc;
    }, { ...target });
  }

  if (isDefined(values)) {
    return values;
  }

  return target;
};

const getValue = value => isFunction(value) ? value() : value;
export const conditionalObj = (obj, ...conditions: { if: boolean; value: any; else?: any }[]) => {
  for (const condition of conditions) {
    if (condition.if) {
      Object.assign(obj, getValue(condition.value));
    } else if (condition.else) {
      Object.assign(obj, getValue(condition.else));
    }
  }

  return obj;
};
